class ConfirmationModalCtrl {

    constructor($scope, $uibModalInstance, title, message) {

        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;

        $scope.title = title;
        $scope.message = message;

        this.$scope.ok = this.ok.bind(this);
        this.$scope.cancel = this.cancel.bind(this);

    }

    ok() {
        this.$uibModalInstance.close();
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

}

angular.module("cpm")
    .controller("ConfirmationModalCtrl", ['$scope', '$uibModalInstance', 'title', 'message', ConfirmationModalCtrl]);


